import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/teamShowcaseApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CompanyStructureTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/CompanyStructureTemplateWidget";
import SmallTeamTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/SmallTeamTemplateWidget";
import DedicatedTeamTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/DedicatedTeamTemplateWidget";
import MusicBandTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/MusicBandTemplateWidget";
import TeamRosterTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/TeamRosterTemplateWidget";
import TeachersTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/TeachersTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/TeamShowcase/ContentTab";
import LayoutTab from "../../../../components/Apps/TeamShowcase/LayoutTab";
import StyleTab from "../../../../components/Apps/TeamShowcase/StyleTab";
import SettingsTab from "../../../../components/Apps/TeamShowcase/SettingTab";

export default function EditLogoShowcase() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Team Showcase");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setTemplateId] = useState(null); 
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);

    const [teamShowcaseTabData, setTeamShowcaseTabData] = useState({
        is_website_frontend: "",  
        is_show_header: 1,
        header_title: "",
        header_caption: "",
        is_call_to_action: 1,
        call_to_action_title: "",
        call_to_action_button_text: "",      
        call_to_action_button_link: "",   
        layout_is_full_width: "",     
        layout_custom_width: "1280", 
        text_align_type: "center",   
        member_background_color: "",   
        text_color: "",   
        links_color: "",   
        call_to_action_button_color: "",   
        widget_background_color: "",   
        font_type: "Default",   
        widget_align_type: "center",   
        widget_title_color: "",   
        widget_caption_color: "",   
        widget_links_color: "", 
        widget_title_size: "24px",   
        widget_caption_size: "16px",  
        popup_background_color: "",  
        popup_text_color: "",  
        popup_links_color: "",  
        message_text_type: "",  
        custom_css: "",   
        custom_js: "",      
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateTeamShowcaseTabData = (key, value) => {
        setTeamShowcaseTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "settings.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setTemplateId(uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setTeamShowcaseTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setTeamShowcaseTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(teamShowcaseTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/team-showcase');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/team-showcase/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId}  updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} setRefreshWidgetList={setRefreshWidgetList} />
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                    )}
                    {activeSection === "Settings" && (
                        <SettingsTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/team-showcase"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/team-showcase/team-showcase.svg`} alt="team-showcase"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/team-showcase/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/team-showcase" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Team Showcase <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Company_Structure_Temp" && (
                      <CompanyStructureTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Small_Team_Temp" && (
                      <SmallTeamTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Dedicated_Team_Temp" && (
                      <DedicatedTeamTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Music_Band_Temp" && (
                      <MusicBandTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Team_Roster_Temp" && (
                      <TeamRosterTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Teachers_Temp" && (
                      <TeachersTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList}  />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 